module.exports = __webpack_public_path__ + "static/media/Siemens-logo.4f5f8671.png";